export const BUTTON_KEYS = {
  DELETE: "delete",
  DUPLICATE: "duplicate",
  DIVIDER: "divider",
  EDIT: "edit",
  EXPORT: "export",
  FAVORITE: "favorite",
  FOLLOW_UP: "followUp",
  FORCE_CHANGE_PASSWORD: "forceChangePassword",
  INFO: "info",
  NEW_FOLLOW_UP: "newFollowUp",
  PROGRESS: "progress",
  RESET: "reset",
  RESTORE: "restore",
  RESEND_INVITE: "resendInvite",
  STATE_EDIT: "stateEdit",
  UPDATE_PASSWORD: "updatePassword",
  USER_ACCESS: "userAccess",
} as const;

// Careful, couple with AntD button type
export const BUTTON_TYPE = {
  DASHED: "dashed",
  DEFAULT: "default",
  LINK: "link",
  PRIMARY: "primary",
  TEXT: "text",
} as const;

// Careful, couple with antd button shape
export const BUTTON_SHAPE = {
  DEFAULT: "default",
  CIRCLE: "circle",
  ROUND: "round",
} as const;

// Careful, couple with antd button size
export const BUTTON_SIZE = {
  large: "large",
  middle: "middle",
  small: "small",
} as const;
